import {
  adobeLogo,
  amazonAwsLogo,
  docusignLogo,
  generalTransportLogo,
  idiSoftwareLogo,
  imogenCarsLogo,
  microsoftLogo,
  paloAltotRibunal,
  serviceSectionBg1,
  serviceSectionBg2,
  serviceSectionBg3,
  triNexLogo,
} from "../Assets/Images/Images";

export const navLinksData = [
  {
    id: 1,
    path: "/technology",
    text: "Technology",
  },
  {
    id: 2,
    path: "/about",
    text: "About",
  },
  {
    id: 3,
    path: "/careers",
    text: "Careers",
  },
];

export const servicesData = [
  {
    id: 1,
    dir: "ltr",
    title: "INTEGRATED MANAGEMENT",
    description: `Comprehensive Information and Data Management
    services form the core of our offerings. We aim to organize,
    secure, and streamline your business data,
    maximizing its value. Our services encompass database
    management, data quality, security, and information strategy,
    driving value and business outcomes.`,
    img: serviceSectionBg1,
    alt: "Robot with one eye and holding a shield",
  },
  {
    id: 2,
    dir: "rtl",
    title: "SOFTWARE SOLUTIONS",
    description: `We offer custom software development services designed
    to meet your business needs. Our team specializes in creating
    efficient, scalable, and robust software solutions that can
    transform your business operations. From crafting intuitive mobile
    apps to architecting complex enterprise systems, we deliver
    solutions tailored to your needs.`,
    img: serviceSectionBg2,
    alt: "Abstract circuit board design with intricate lines and patterns, representing technology or electronics.",
  },
  {
    id: 3,
    dir: "ltr",
    title: "TECHNOLOGY",
    description: `Our IT Consulting services provide strategic guidance in
    leveraging technology for growth. We offer system design and project
    management, ensuring your technology infrastructure aligns with your
    business objectives. Trust us to be your navigators in the complex
    and ever-evolving tech landscape.`,
    img: serviceSectionBg3,
    alt: "An electronic white door",
  },
];

export const infoStatsData = [
  {
    id: 1,
    title: "Employees",
    value: "5",
    lineDelay: ".3s",
  },
  {
    id: 2,
    title: "Core teams",
    value: "2",
    lineDelay: ".5s",
  },
  {
    id: 3,
    title: "Capital",
    value: "1M$",
    lineDelay: ".4s",
  },
  {
    id: 4,
    title: "Partners",
    value: "10",
    lineDelay: ".6s",
  },
];

export const industryLogosData = [
  {
    id: 1,
    title: "VXV DATA",
    logo: generalTransportLogo,
    delay: ".2s",
    width: "150px",
    alt: "Logo of VXV DATA, featuring a pair of angle brackets facing away from each other",
  },
  {
    id: 2,
    title: "I-AI SOFTWARE",
    logo: idiSoftwareLogo,
    delay: ".4s",
    width: "88px",
    alt: "Logo of I-AI SOFTWARE, featuring a stylized, grey, curved shape resembling a wing or blade.",
  },
  {
    id: 3,
    title: "IMAGINE CONSULTING",
    logo: imogenCarsLogo,
    delay: ".6s",
    width: "88px",
    alt: "Logo of IMAGINE CONSULTING, featuring stylized letters ‘I’ and ‘C’",
  },
  {
    id: 4,
    title: "777 INDEX",
    logo: triNexLogo,
    delay: ".8s",
    width: "128px",
    alt: "Logo of 777 INDEX, featuring stylized numbers ‘777’ in a modern design.",
  },
];

export const careersSliderData = [
  {
    id: 1,
    title: "INTEGRATION ENGINEER",
    location: "Remote",
    description: `Seeking a detail-oriented Integration Engineer skilled in system
      architecture, pretrained in multiple languages, and passionate about
      data-driven solutions.`,
  },
  {
    id: 2,
    title: "DATA SCIENTIST",
    location: "Remote",
    description: `In search of a Data Scientist with a strong statistical background,
    deep understanding of machine learning algorithms, and passion for turning
    data into actionable insights.`,
  },
  {
    id: 3,
    title: "ARTIFICIAL INTELLIGENCE RESEARCHER",
    location: "San Francisco, CA",
    description: `
    We're on the lookout for an Artificial Intelligence Researcher with expertise in AI,
    machine learning, and a drive to push the boundaries of technology.`,
  },
  {
    id: 4,
    title: "DEEP LEARNING ENGINEER",
    location: "San Francisco, CA",
    description: `A Deep Learning Engineer with a strong foundation in neural networks,
    experience with large datasets, and a passion for AI-driven solutions is sought.`,
  },
];

export const socialMedia = [
  {
    id: 1,
    link: "#",
    media: "LinkedIn",
  },
  {
    id: 2,
    link: "#",
    media: "Facebook",
  },
  {
    id: 3,
    link: "#",
    media: "Twitter",
  },
  {
    id: 4,
    link: "#",
    media: "Instagram",
  },
];

export const userExperienceData = [
  {
    id: 1,
    title: "Enhanced User Experience",
    description: `our focus is on creating user-friendly, intuitive software solutions
    that enhance productivity and streamline operations. We are committed
    to improving the user experience by designing systems that simplify
    complex tasks, making them more manageable and efficient.`,
  },
  {
    id: 2,
    title: "PERFORMANCE AND SCALABILITY",
    description: `
    Performance and scalability are at the core of our software development approach.
    We design solutions that not only meet the immediate needs of businesses but also
    grow with them over time. Our emphasis is on creating efficient, high-performing
    systems that can adapt to increasing demands and ensure sustainable growth.`,
  },
];

export const dataSecurityData = [
  {
    id: 1,
    title: "STRATEGIC DATA MANAGEMENT",
    description: `We provide strategic data management solutions, designed to improve
    data quality, ensure compliance, and enable businesses to make data-driven decisions.`,
  },
  {
    id: 2,
    title: "ADVANCED CYBER SECURITY",
    description: `Our commitment to advanced cybersecurity ensures the integrity and
    safety of your data. We implement robust security measures to protect
    against threats and maintain the confidentiality, integrity,
    and availability of your business-critical information.`,
  },
];

export const journeySliderData = [
  {
    year: "2016",
    title: "SAN FRANCISCO HQ OPENS",
    description: `Aster Information Limited was founded with a vision to revolutionize
    Information Management and IT solutions, initiating our data-empowered journey.`,
  },
  {
    year: "2017",
    title: "FIRST PROTOTYPE IS TEST-DRIVEN",
    description: `We aim to expand our AI-infused solutions, becoming a trusted partner
    in data-driven decision making across various industries.`,
  },
  {
    year: "2018",
    title: "PARTNERSHIP WITH TRI-NEX & GENERAL TRANSPORT INITIATED",
    description: `Aster Information Limited was founded with a vision to revolutionize
      Information Management and IT solutions, initiating our data-empowered journey.`,
  },
  {
    year: "2019",
    title: "TESTING EXPANDS TO ARIZONA & NEW MEXICO",
    description: `We aim to expand our AI-infused solutions, becoming a trusted partner
      in data-driven decision making across various industries.`,
  },
  {
    year: "2020",
    title: "PRODUCTION BEGINS!",
    description: `Aster Information Limited was founded with a vision to revolutionize
      Information Management and IT solutions, initiating our data-empowered journey.`,
  },
  {
    year: "2021",
    title: "FIRST 1,000 CARS SOLD",
    description: `We aim to expand our AI-infused solutions, becoming a trusted partner
      in data-driven decision making across various industries.`,
  },
  {
    year: "2022",
    title: "ASTER IS FOUNDED",
    description: `Aster Information Limited was founded with a vision to revolutionize
      Information Management and IT solutions, initiating our data-empowered journey.`,
  },
  {
    year: "2023",
    title: "Future Prospects",
    description: `We aim to expand our AI-infused solutions, becoming a trusted partner
      in data-driven decision making across various industries.`,
  },
];

export const partnersSectionData = [
  {
    id: 1,
    img: microsoftLogo,
    partner: "Microsoft logo",
    website: "https://www.microsoft.com",
  },
  {
    id: 2,
    img: amazonAwsLogo,
    partner: "Amazon Web Services logo",
    website: "https://aws.amazon.com",
  },
  {
    id: 3,
    img: adobeLogo,
    partner: "Adobe logo",
    website: "https://www.adobe.com",
  },
  {
    id: 4,
    img: docusignLogo,
    partner: "Docusign logo",
    website: "https://www.docusign.com",
  },
  {
    id: 5,
    img: paloAltotRibunal,
    partner: "Palo Alto logo",
    website: "https://www.paloaltonetworks.com",
  },
];

export const jobsCardsData = [
  {
    id: 1,
    title: "INTEGRATION ENGINEER",
    location: "Remote",
    description: `Seeking a detail-oriented Integration Engineer skilled in system
    architecture, proficient in multiple languages, and passionate about data-driven solutions.`,
  },
  {
    id: 2,
    title: "DATA SCIENTIST",
    location: "Remote",
    description: `In search of a Data Scientist with a strong statistical background, deep
    understanding of machine learning algorithms, and passion for turning data into actionable insights.`,
  },
  {
    id: 3,
    title: "ARTIFICIAL INTELLIGENCE RESEARCHER",
    location: "Remote",
    description: `We're on the lookout for an Artificial Intelligence Researcher with
    expertise in AI, machine learning, and a drive to push the boundaries of technology.`,
  },
  {
    id: 4,
    title: "​DEEP LEARNING ENGINEER",
    location: "Remote",
    description: `A Deep Learning Engineer with a strong foundation in neural networks,
    experience with large datasets, and a passion for AI-driven solutions is sought.`,
  },
];

export const joinUsInputsData = [
  {
    id: 1,
    label: "First Name",
    type: "text",
    name: "firstName",
    required: true,
    isValid: false,
    regex: /^[a-z]+$/i,
  },
  {
    id: 2,
    label: "Last Name",
    type: "text",
    name: "lastName",
    required: true,
    isValid: false,
    regex: /^[a-z]+$/i,
  },
  {
    id: 3,
    label: "Email",
    type: "email",
    name: "email",
    required: true,
    isValid: false,
    regex: /^\w+@\w+\.\w+$/,
  },
  {
    id: 4,
    label: "Phone",
    type: "tel",
    name: "phone",
    required: false,
    isValid: true,
    regex: /^\d{9,11}$/,
  },
  {
    id: 5,
    label: "Position",
    type: "select",
    name: "position",
    options: [
      "Electrical Engineer",
      "Data Scientist",
      "Artificial Intelligence Researcher",
      "Deep Learning Engineer",
      "Other: Submit Your CV",
    ],
    required: true,
    isValid: false,
  },
  {
    id: 6,
    label: "CV URL",
    type: "text",
    name: "cvUrl",
    required: true,
    isValid: false,
    regex: /^((https?:\/\/)www\.)?([a-z0-9-]+\.)[a-z]+$/,
  },
  {
    id: 7,
    label: "Linkedin URL",
    type: "text",
    name: "linkedinUrl",
    required: false,
    isValid: true,
    regex: /^((https?:\/\/)www\.)?([a-z0-9-]+\.)[a-z]+$/,
  },
  {
    id: 8,
    label: "Any Comments",
    type: "textarea",
    name: "comment",
    required: false,
    isValid: true,
    ignoreValidation: true,
    placeholder: "Tell Us a Bit About Yourself",
  },
];

export const jobResponsibilities = [
  {
    text: "I'm a paragraph. Click here to add your own text and edit me. I’m a great place for you to tell a story and let your users know a little more about you.",
    id: 1,
  },

  {
    text: "I'm a paragraph. Click here to add your own text and edit me. I’m a great place for you to tell a story and let your users know a little more about you.",
    id: 2,
  },

  {
    text: "I'm a paragraph. Click here to add your own text and edit me. I’m a great place for you to tell a story and let your users know a little more about you.",
    id: 3,
  },

  {
    text: "I'm a paragraph. Click here to add your own text and edit me. I’m a great place for you to tell a story and let your users know a little more about you.",
    id: 4,
  },

  {
    text: "I'm a paragraph. Click here to add your own text and edit me. I’m a great place for you to tell a story and let your users know a little more about you.",
    id: 5,
  },

  {
    text: "I'm a paragraph. Click here to add your own text and edit me. I’m a great place for you to tell a story and let your users know a little more about you.",
    id: 6,
  },
];

export const whoYouAreData = [
  {
    text: "I'm a paragraph. Click here to add your own text and edit me. I’m a great place for you to tell a story and let your users know a little more about you.",
    id: 1,
  },

  {
    text: "I'm a paragraph. Click here to add your own text and edit me. I’m a great place for you to tell a story and let your users know a little more about you.",
    id: 2,
  },

  {
    text: "I'm a paragraph. Click here to add your own text and edit me. I’m a great place for you to tell a story and let your users know a little more about you.",
    id: 3,
  },

  {
    text: "I'm a paragraph. Click here to add your own text and edit me. I’m a great place for you to tell a story and let your users know a little more about you.",
    id: 4,
  },

  {
    text: "I'm a paragraph. Click here to add your own text and edit me. I’m a great place for you to tell a story and let your users know a little more about you.",
    id: 5,
  },
];
